<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="基本信息"
                left-arrow
                @click-left="onClickLeft"
        >
            <!--通过插槽自定义导航栏右侧的内容 start-->
            <template #right>
                <van-icon name="wap-home-o" size="20" @click="onClickRight"/>
            </template>
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!--内容 start-->
        <div style="margin-top: 1.5rem">
            <div style="margin: 10px 0px">
                <van-notice-bar color="#1989fa" background="#ecf9ff">
                    我的信息
                </van-notice-bar>
                <van-cell title="编号" :value="info.salesman_num"/>
                <van-cell title="姓名"   :value="info.name"/>
                <van-cell title="手机号" :value="info.tel"/>
                <!-- <van-cell title="收款码数量" :value="info.code_count"/> -->
            </div>
        </div>
        <!--内容 end-->
    </div>
</template>

<script>
    import VueCookie from "vue-cookies";

    export default {
        name: "SalesmanBaseInfo", //基本信息
        data(){
            return{
                info:[],
            }
        },
        methods:{
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/SalesmanInformation');
            },
            // 右侧icon跳转至商户首页
            onClickRight() {
                // 返回商户首页
                this.$router.push('/SalesmanHome');
            },
            //初始化页面
            Basic(){
                var that = this;
                const salesman_id = window.localStorage.getItem('salesman_id');
                // var salesmanInfo = VueCookie.get("salesmanInfo");
                this.$http.get('/wechat/api.salesman/salesmanInfo', {
                    params: {
                        // id: salesmanInfo.id,
                        id:salesman_id
                    }
                }).then(response => {
                    that.info = response.data.data
                })
            },
        },
        mounted(){
            this.Basic()
        }
    }
</script>

<style scoped>
    .content_title{
        font-size: 18px;
    }
</style>